
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hdfc-life",
      function () {
        return require("private-next-pages/hdfc-life.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hdfc-life"])
      });
    }
  